









































import image from '@/assets/images/no-image-available.png';
import pdfLogo from '@/assets/images/pdf-icon.png';
import { companyHost } from '@/const/companyHost';
import Vue, { PropType } from 'vue';
import pdf from 'vue-pdf';

export default Vue.extend({
  name: 'ImagePreview',
  components: {
    pdf,
  },
  props: {
    src: {
      type: [String] as PropType<string | null | undefined>,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    canDelete: {
      type: Boolean,
      default: true,
    },
    canUpdate: {
      type: Boolean,
      default: true,
    },
    id: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    showModal: false,
    image,
    companyHost,
    isPdf: false,
  }),
  computed: {
    canUpdateSynced: {
      get(): boolean {
        return this.canUpdate;
      },
      set(value: boolean): void {
        this.$emit('update:canUpdate', value);
      },
    },
    isSourcePdf(): boolean {
      if (!this.src) return false;
      const srcLower = this.src.toLowerCase();
      return srcLower.endsWith('pdf') || srcLower.includes('data:application/pdf') || srcLower.includes('data:application/x-www-form-urlencoded');
    },
    urlImage(): string {
      if (!this.src) return image;
      return this.isSourcePdf ? pdfLogo : this.src;
    },
    urlImagePdf(): string {
      return this.src || '';
    },
  },
  mounted(): void {
    document.addEventListener('keydown', this.closePreview);
    if (this.$route.name !== 'new-company') {
      this.canUpdateSynced = true;
    }
  },
  destroyed(): void {
    document.removeEventListener('keydown', this.closePreview);
  },

  methods: {
    closePreview(e: KeyboardEvent): void {
      if (e.key === 'Escape') {
        this.close();
      }
    },
    open(): void {
      this.isPdf = this.isSourcePdf;
      this.showModal = true;
    },
    trash(): void {
      this.$emit('trash', this.id);
    },
    edit(): void {
      this.$emit('edit', this.id);
    },
    close(): void {
      this.showModal = false;
    },
  },
});
